export const SECTION_ENTERED_SCREEN = '[SCROLLSPY] SECTION ENTERED SCREEN';
export const SECTION_EXITED_SCREEN = '[SCROLLSPY] SECTION EXITED SCREEN';

export default {
  SECTION_ENTERED_SCREEN,
  SECTION_EXITED_SCREEN,
};
